import { io } from "socket.io-client";
import {getKefu} from "../api/app";
import config from "../config.js";
import tip from '@/assets/tip.mp3';
import online from '@/assets/online.mp3';
import Event from './event.js';
import request from '@/plugins/axios'
import Timers from './timer.js';
import { Message } from 'element-ui'

class net {
    tipVoice = false; //消息声音提醒
    tipMsgTime= 15000; //未读发送短信时间
    MsgTip = false;
    userInfo = {};//用户信息存储
    async init(){
        console.log("连接中")
        let userData  = await getKefu();
        this.userInfo = {
            "user_id":userData.admin_id,//ID
            "dept_id":userData.dept_id[0],
            "avatar": userData.avatar,
            "nickname": userData.name,
            "dept_name":userData.dept_name,
            "token": userData.token,
            "user_type":"kefu",
            "game_ids": userData.game_ids//游戏
        }
        const socket = io(config.wsURL,{
            transports: ['websocket'],
            auth:{
                token: this.userInfo.token,
                type: 'kefu'
            }
        })
        this.socket = socket
        this.socket.on("connected", this.connected.bind(this))//连接
        this.socket.on("disconnect", this.disconnected.bind(this))//断开连接
    }

    connected(){
        Event.$emit("connected",this.userInfo);
        this.socket.on('message', this.onMsg.bind(this))//收到消息
        this.socket.on("onSentMessage",this.onSent.bind(this));//发送消息回执
        this.socket.on("onlineUser",this.onlineUser.bind(this));//获取所有用户在线
        this.socket.on("read",this.onRead.bind(this));//服务器发给我们的已读回执
        this.socket.on("errorMessage",this.onErrorMessage.bind(this));//服务器发给我们的已读回执
    }

    disconnected(){
        this.socket.off('message')//收到消息
        this.socket.off('threadUpdate');//会话更新
        this.socket.off('offlineUser');//监听用户下线
        this.socket.off('online');//获取所有在线用户
        this.socket.off("read");//已读回执
        this.socket.off("onSentMessage");
        this.socket.off("onlineUser");//用户上线
        this.socket.off("read");//已读回执
        this.socket.off("recall");//撤回回执
        this.socket.off("errorMessage");//服务器发给我们的错误信息
        Event.$emit("disconnected",this.userInfo);
    }

    onErrorMessage(msg){
        Message.error(msg.msg);
    }

    async onlineUser(msg){
        if(this.tipVoice){
            let audio = document.createElement('audio');
            if(audio){
                audio.src = online;
                await audio.play();
                audio.remove();
            }
        }
    }

    //标记已读
    upRead(msg){
        if(msg.from.indexOf("kefu_")!=-1) return;
        this.socket.emit("read",msg);
    }

    //撤回消息
    recall(msg){
        // if(msg.from.indexOf("kefu_"+this.userInfo.user_id)<0) return;
        this.socket.emit("recall",msg);
    }

    //撤回消息回执
    recallBack(msg){
    }

    //组装发送数据
    buildMsg(to,content,type="private",content_type=1,thread_id=null){
        let type_map = {1:"text",2:"image",3:"link"};
        let datas = {
            from:"kefu_"+this.userInfo.user_id,
            to:to,
            msg_type:type,//private私聊 group群聊
            type:content_type,//1~8 1文字 2图片 3链接  7系统提示 8卡片
            fromData:{
                user_type:this.userInfo.user_type,
                avatar: this.userInfo.avatar,
                nickname: this.userInfo.nickname
            },
            payload:{
                type:type_map[content_type],
                txt:content,
                thread_id:thread_id
            }
        }
        return datas;
    }

    onlineUsers(){
        this.socket.emit("online");
    }

    //消息发送成功回执
    async onSent(msg){
        await this.saveMsg(msg);
        this.socket.emit('sendMessage',msg);
    }

    async onMsg(msg){
        if(msg.from.indexOf("kefu_")!=-1) return;
        let audio = document.createElement('audio');
        if(audio){
            audio.src = tip;
            if(this.tipVoice) await audio.play();
            audio.remove();
        }
    }

    sendMsg(msg){
        this.socket.emit("message",msg);
    }

    onRead(msg){ }

    async saveMsg(msg){
        //信息存储到服务端
        let msg_datas = {
            type:msg.msg_type,
            user_id:msg.msg_type=="private"?msg.to.replace("user_",""):null,
            group_id:msg.msg_type=="private"?null:msg.to.replace("group_",""),
            content:msg,
            msg_sn:msg.timestamp,
            messageId:msg.messageId//GoeasyMessageId
        }
        let m = await request.post("/tenantapi/kefu.kefu/send",msg_datas);
        //未读短信提醒
        if(msg.msg_type==='group') return;//群消息未读不发送
        let to = msg.to.replace("user_","");
        //清空消息时钟短信提醒
        if(this.MsgTip === false) return;
        if(Timers.msgTipTimer[to]) clearTimeout(Timers.msgTipTimer[to]);//防止消息重复发送
        //15s后发送消息
        Timers.msgTipTimer[to] = setTimeout(()=>{
            request.post("/tenantapi/kefu.kefu/sendMsgTip",{user_id:to,scene:"MSGTIP"}).then((res)=>{
            });
        }, this.tipMsgTime);

    }
}

export default new net()

